export const config = {
  // getMyCollege: "https://api.arinfotechsolutions.com",
  // apiUrl: "https://api.arinfotechsolutions.com",
  // LOCAL DEV (run backend on port 8080 first):
  getMyCollege: "http://localhost:8080",
  apiUrl: "http://localhost:8080",
  cookieName: "ar_user",
  sessionCookie: "ar_sess",
};